document.addEventListener('DOMContentLoaded', function () {
  const flowchart = document.querySelector('.flowchart');
  if (!flowchart) return;

  // Helper for cross-fade and translate-y cycling with custom cubic-bezier
  function setupChartTextCycler(selector) {
    const el = flowchart.querySelector(selector);
    if (!el) return;
    const dataList = el.getAttribute('data-list');
    if (!dataList) return;
    const items = dataList.split(',').map(item => item.trim()).filter(Boolean);
    if (items.length === 0) return;
    let current = 0;
    el.innerText = items[current];
    el.style.opacity = 1;
    el.style.transition = 'opacity 0.3s cubic-bezier(0.7,0,1,1), transform 0.3s cubic-bezier(0.7,0,1,1)';
    el.style.transform = 'translateY(0)';
    setInterval(() => {
      // Fade out and move up
      el.style.transition = 'opacity 0.3s cubic-bezier(0.7,0,1,1), transform 0.3s cubic-bezier(0.7,0,1,1)';
      el.style.opacity = 0;
      el.style.transform = 'translateY(-20px)';
      setTimeout(() => {
        // Next item, move below and fade in
        current = (current + 1) % items.length;
        el.innerText = items[current];
        el.style.transition = 'none';
        el.style.transform = 'translateY(20px)';
        // Force reflow to apply the transform before fading in
        void el.offsetWidth;
        el.style.transition = 'opacity 0.3s cubic-bezier(0.7,0,1,1), transform 0.3s cubic-bezier(0.7,0,1,1)';
        el.style.opacity = 1;
        el.style.transform = 'translateY(0)';
      }, 500);
    }, 3000);
  }

  setupChartTextCycler('.chart-text-1');
  setupChartTextCycler('.chart-text-2');
});
